import React, { Component } from 'react';
import PaymentByCreditCard from "./PaymentByCreditCard"
import {PAYMENT_METHOD_ALIPAY, PAYMENT_METHOD_CREDIT_CARD} from "../Const"
import PaymentByAliPay from "./PaymentByAliPay";

export class Payment extends Component {
    render() {
        let payment;
        if ( this.props.payment_metod === PAYMENT_METHOD_CREDIT_CARD){
            payment = ( <PaymentByCreditCard
                    {...this.props}
                />
            )
        }else if (this.props.payment_metod === PAYMENT_METHOD_ALIPAY) {
            payment = ( <PaymentByAliPay
                    {...this.props}
                />
            )

        } else {
            payment =  (<div>Unsupported payment method {this.props.method} </div>)
        }

        return ( <div> {payment} </div>)
    }
}

export default Payment;
